import { cn } from "@/lib/utils"
import React from "react"
import { AnimatedElement } from "../animations/AnimatedElement"

interface ProseContainerProps {
  children: React.ReactNode
  className?: string
  size?: "default" | "lg" | "2xl"
  alignment?: "left" | "center"
}

/**
 * ProseContainer - Consistent container for all prose content across the site
 */
export function ProseContainer({
  children,
  className = "",
  size = "lg",
  alignment = "left",
  maxWidth = "max-w-screen-xl",
}: ProseContainerProps & { maxWidth?: string }) {
  if (className.includes("text-center")) {
    alignment = "center"
  }

  const containerClasses = cn(
    maxWidth,
    "mx-auto",
    size === "default" ? "prose" : `prose-${size}`,
    "dark:prose-invert",
    alignment === "center" ? "text-center" : "text-left",
    className
  )

  return (
    <AnimatedElement
      animationType="animate"
      className={containerClasses}
      // style={{
      //   border: "1px solid red",
      // }}
    >
      {children}
    </AnimatedElement>
  )
}
